﻿$.fn.dxCtrlImgStrConUti = function custom_dxCtrlImgStrConUti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlimgstrconuti dx-ctrl");
        this.createInstance(new cdxCtrlImgStrConUti(this, option));
    }
    return this;
}

window.cdxCtrlImgStrConUti = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.hideIcone == 'undefined') option.hideIcone = false

    var $DivContainer = null
    var $DivIcone = null
    var $DivText = null
    function mConstruit() {
        container.empty();
        container.off("click")

        srcImg1 = ""
        srcImg2 = ""

        if (typeof option.idTable != 'undefined') {
            container.attr("id_table", option.idTable)
            container.attr("id", option.id)
        }

        $DivImgStr = null
        $DivImgCon = null

        $Icone1 = null
        $Icone2 = null

        $DivContainer = $("<div style='overflow:hidden;height:100%;width:100%;' class='image'/>").appendTo(container)
        if (typeof option.text != 'undefined' && option.text != null && option.text.length > 0) $DivContainer.attr("title", option.text)
        $DivContainer.css({
            "position": "relative",
            "height": "100%",
            "width": "100%",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "background-color": theme.backgroundcolorBase,
            "border": theme.border,
            "overflow": "hidden",
            "border-radius": "20%",
            "color": theme.color
        })
        //if (option.idTable == option.bddCtrl.getObjet("utilisateur").mGetTable().id_table) $DivContainer.css("border-radius", "50%")

        //$DivIcone = $("<div/>")
        //$DivIcone.css({
        //    "position": "absolute",
        //    "z-index": "0",
        //    "display": "",
        //    "display": "flex",
        //    "align-items": "center",
        //    "justify-content": "center",
        //    "width": "100%",
        //    "height": "100%",
        //    "font-size": (container.innerHeight()) + "px"
        //})
        //$DivIcone.appendTo($DivContainer)

        $DivText = $("<div style='position:absolute;bottom:0;width:100%;text-align:center;z-index:2;color:" + theme.backgroundcolorAccent + "'/>").appendTo($DivContainer)
        $DivText.css({
            "position": "absolute",
            "bottom": "0",
            "width": "100%",
            "text-align": "center",
            "z-index": "2",
            "color": theme.backgroundcolorAccent, //.backgroundcolorTooltip,
            "font-size": ((option.size * 15 / 100) * 2) + "px",
            "font-weight": "bold",
            "text-shadow": "0px 0px 2px " + theme.color,
            "line-height": 1,
            "overflow": "hidden",
            "text-overflow": "ellipsis",
        })
        if (option.hideText) $DivText.hide()

        mRempliIcone()
        if (typeof option.count != 'undefined') { mRempliCount() }
        else { mRempliText() }
        if (typeof option.icon1 == 'undefined') mRempliImage()

        resizeObserver.mAdd([container, $DivContainer], function () {
            mResize()
        })
        mResize()
        window.setTimeout(function () { mResize() }, 100)

        if (option.allowClickImage) {
            container.addClass("state-hover")
            container.on("click", function (e) {
                e.stopPropagation()
                var srcImgRef = srcImg1
                if (option.bddCtrl.table.mGetItem(option.idTable).nom == "structures_contact") {
                    srcImgRef = srcImg2
                }
                if (srcImgRef == null || srcImgRef == "") {
                    var searchStringWeb = ((typeof option.text != 'undefined') ? option.text : "")
                    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                        bddCtrl: option.bddCtrl,
                        icone: false,
                        imgInternet: true,
                        multiple: false,
                        selectedItem: "machine",
                        accept: ".png,.jpg,.jpeg,.gif,.bmp",
                        optionImgInternet: {
                            bddCtrl: option.bddCtrl,
                            searchStringImageWeb: searchStringWeb
                        },
                        onValide: function (lstUrlFile) {
                            if (lstUrlFile.length > 0) {
                                jaugeDemarrage.mShow();
                                (new cImage(option.bddCtrl)).mImgUrltoData64(lstUrlFile[0], function (dataUrl) {
                                    jaugeDemarrage.mHide();
                                    pop.hide()
                                    mCrop(dataUrl);
                                }, function () {
                                    jaugeDemarrage.mHide();
                                    mNotify("Impossible d'utiliser cette image", "error", 6000)
                                })
                            }
                        }
                    }).dxCtrlFileUploaderPopup("instance")
                } else {
                    mCrop(srcImgRef)
                }
            })
        }

        if (typeof option.onContentReady != 'undefined') {
            option.onContentReady(Me)
        }

    }

    function mResize() {
        var tailleRef = container.innerHeight()
        if (tailleRef > container.innerWidth()) tailleRef = container.innerWidth()
        tailleRef -= 6 / 24 * tailleRef
        $Icone1.css({
            "font-size": tailleRef + "px"
        })
        var leftRef = (container.innerWidth() - $Icone1.innerWidth()) / 2
        var topRef = (container.innerHeight() - $Icone1.innerHeight()) / 2
        $Icone1.css({
            "left": leftRef + "px",
            top: topRef + "px"
        })
        if ($Icone2) $Icone2.css({
            "font-size": (tailleRef / 1.5) + "px"
        })
        if (typeof option.count == 'undefined') { $DivText.css("font-size", tailleRef / 3 + "px") }
        else { $DivText.css("font-size", tailleRef / 2 + "px") }
    }

    var $Icone1 = null
    var $Icone2 = null
    function mRempliIcone() {
        if ($Icone1) $Icone1.remove()
        var icon1 = option.icon1
        //if (option.id == 99999) debugger;
        if (typeof option.idTable != 'undefined' && option.idTable != null && option.bddCtrl.table.mGetItem(option.idTable).nom == 'utilisateur') {
            if (option.id == null || option.id == 99999) { icon1 = "fas fa-robot" }
            else if (option.id <= 99998) { icon1 = "fas fa-universal-access" }
        }
        if (typeof icon1 == 'undefined' || icon1 == null) icon1 = ((option.idTable == option.bddCtrl.table.mGetItemFromNom("structures").id_table) ? "fas fa-home" :
            ((option.idTable == option.bddCtrl.table.mGetItemFromNom("contact").id_table) ? "fas fa-portrait" :
                ((option.idTable == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table) ? "fas fa-home" :
                    ((option.idTable == option.bddCtrl.table.mGetItemFromNom("compte_client").id_table) ? "fas fa-address-card" :
                        ((option.idTable == option.bddCtrl.table.mGetItemFromNom("compte_client_utilisateur").id_table) ? "fas fa-address-card" :
                            ((option.idTable == option.bddCtrl.table.mGetItemFromNom("utilisateur").id_table) ? "fas fa-user" :
                                ((option.idTable == option.bddCtrl.table.mGetItemFromNom("article").id_table) ? "fas fa-barcode" : "")))))))
        var icon2 = option.icon2
        if (typeof icon2 == 'undefined') icon2 = ((option.idTable == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table) ? "fas fa-portrait" : ((option.idTable == option.bddCtrl.table.mGetItemFromNom("compte_client_utilisateur").id_table) ? "fas fa-child" : ""))
        $Icone1 = $("<i class='" + icon1 + " fa-fw icone' style='position:absolute;z-index:1;'/>").appendTo($DivContainer)
        if (icon2.length > 0) {
            $Icone2 = $("<i class='" + icon2 + " fa-fw dx-theme-accent-as-text-color' style='font-size:66%;position:absolute;bottom:0;right:0;z-index:3;'/>").appendTo($DivContainer)
        }
        if (option.hideIcone) $Icone1.hide()
    }
    function mRempliText() {
        $DivText.empty()
        var txt = ""
        if (typeof option.text != 'undefined' && option.text != null && option.text.length > 0) {
            if (option.text.trim().split(" ").length > 1) {
                txt = option.text.trim().split(" ")[0][0] + option.text.trim().split(" ")[1][0]
            } else {
                if (option.text.trim().length > 1) {
                    txt = option.text.trim()[0] + option.text.trim()[1]
                } else {
                    txt = option.text.trim()[0]
                }
            }
        }
        $DivText.text((typeof txt == 'undefined') ? "" : txt.toUpperCase())
    }
    function mRempliCount() {
        $DivText.empty()
        $DivText.css("font-size", container.innerHeight() / 2 + "px")
        $DivText.css("color", "red")
        $DivText.css("font-weight", "bold")
        $DivText.css("font-family", "barlow condensed")
        $DivText.text(option.count)
    }

    var $DivImgStr = null
    var $DivImgCon = null
    var srcImg1 = ""
    var srcImg2 = ""
    function mRempliImage() {
        if (typeof option.url_image != "undefined") {
            //on a une image en dur
            var fichier = new cFichier(option.bddCtrl, option.url_image)
            $DivImgStr = $("<div style='position:absolute;height:100%;width:100%;z-index:2'/>").appendTo($DivContainer)
            fichier.mGetElementImage(null, null, false, false).appendTo($DivImgStr)
            srcImg1 = option.data64Image
            $Icone1.hide()
        } else {
            if (typeof option.idTable != 'undefined' && option.idTable != null) {
                if (option.bddCtrl.table.mGetItem(option.idTable).nom != "utilisateur" || (option.bddCtrl.table.mGetItem(option.idTable).nom == 'utilisateur' && option.id != 99999)) {
                    if ($DivImgStr) { $DivImgStr.remove(); $DivImgStr = null }
                    if ($DivImgCon) { $DivImgCon.remove(); $DivImgCon = null }
                    var urlFirst = null
                    var urlSecond = null
                    if (option.bddCtrl.table.mGetItem(option.idTable).nom == "structures_contact") {
                        var idStr = null
                        var idCon = null
                        if (typeof option.dataTemplate != 'undefined' && option.dataTemplate != null) {
                            idStr = option.dataTemplate.id_str
                            idCon = option.dataTemplate.id_con
                        } else {
                            var dataStrcon = option.bddCtrl.getObjet("structures_contact", option.id).data
                            idStr = dataStrcon.id_structures
                            idCon = dataStrcon.id_contact
                        }
                        urlFirst = option.bddCtrl.repertoireImageTable.substring(1) + "/structures/" + idStr + ".png"
                        urlSecond = option.bddCtrl.repertoireImageTable.substring(1) + "/contact/" + idCon + ".png"
                    } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == "compte_client_utilisateur") {
                        var dataCptCliUti = option.bddCtrl.getObjet("compte_client_utilisateur", option.id).data
                        urlFirst = option.bddCtrl.repertoireImageTable.substring(1) + "/compte_client/" + dataCptCliUti.id_compte_client + ".png"
                        urlSecond = option.bddCtrl.repertoireImageTable.substring(1) + "/compte_client_utilisateur/" + dataCptCliUti.id_compte_client_utilisateur + ".png"
                    } else {
                        urlFirst = option.bddCtrl.repertoireImageTable.substring(1) + "/" + option.bddCtrl.table.mGetItem(option.idTable).nom + "/" + option.id + ".png"
                    }

                    //// document.URLRacine
                    //$.ajax({
                    //    url: urlFirst + urlFirst,
                    //    type: 'GET',
                    //    statusCode: {
                    //        404: function () {
                    //            if ($DivImgStr) {
                    //                $DivImgStr.remove()
                    //                $DivImgStr = null
                    //                srcImg1 = ""
                    //            }
                    //        }
                    //    },
                    //    success: function () {
                    //        var fichier = new cFichier(option.bddCtrl, urlFirst)
                    //        $DivImgStr = $("<div style='position:absolute;z-index:1;height:100%;width:100%;z-index:2'/>").appendTo($DivContainer)
                    //        fichier.mGetElementImage(null, null, false, false).appendTo($DivImgStr)
                    //        srcImg1 = urlFirst
                    //        $Icone1.hide()
                    //    }
                    //});

                    option.bddCtrl.mAjaxCall({
                        command: "verifexistenceimage",
                        url: urlFirst
                    }, function (data) {
                        if (data.exist == "1") {
                            var fichier = new cFichier(option.bddCtrl, urlFirst)
                            $DivImgStr = $("<div style='position:absolute;height:100%;width:100%;z-index:2'/>").appendTo($DivContainer)
                            fichier.mGetElementImage(null, null, false, false).appendTo($DivImgStr)
                            srcImg1 = urlFirst
                            $Icone1.hide()
                        } else {
                            if ($DivImgStr) {
                                $DivImgStr.remove()
                                $DivImgStr = null
                                srcImg1 = ""
                            }
                        }
                    })
                    if (urlSecond != null) {
                        option.bddCtrl.mAjaxCall({
                            command: "verifexistenceimage",
                            url: urlSecond
                        }, function (data) {
                            if (data.exist == "1") {
                                var fichier = new cFichier(option.bddCtrl, urlSecond)
                                $DivImgCon = $("<div style='position:absolute;bottom:0;right:0;height:60%;width:60%;opacity:1;border-top-left-radius:25%;z-index:3;box-shadow: 0 0 10px 2.5px #000000;'/>").appendTo($DivContainer)
                                fichier.mGetElementImage(null, null, false, false).appendTo($DivImgCon)
                                $Icone2.hide()
                                srcImg2 = urlSecond
                            } else {
                                $Icone2.show()
                                if ($DivImgCon) {
                                    $DivImgCon.remove()
                                    $DivImgCon = null
                                    srcImg2 = ""
                                }
                            }
                        })
                    }
                }
            }
        }

    }

    this.mReload = function () { mConstruit() }

    var dataImage = null;
    function mCrop(urlImg) {
        var pathNameImageToSave = ""
        var idTableRef = option.idTable
        var idRef = option.id
        if (option.bddCtrl.table.mGetItem(option.idTable).nom == "structures_contact") {
            var dataContact = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.idTable).nom, option.id).objetMetier.mGetDataContact()
            pathNameImageToSave = option.bddCtrl.repertoireImageTable.substring(1) + "/" + option.bddCtrl.table.mGetItem(option.idTable).nom + "/" + dataContact.id_contact + ".png"
            idTableRef = option.bddCtrl.table.mGetItemFromNom("contact").id_table
            idRef = dataContact.id_contact
        } else {
            pathNameImageToSave = option.bddCtrl.repertoireImageTable.substring(1) + "/" + option.bddCtrl.table.mGetItem(option.idTable).nom + "/" + option.id + ".png"
        }

        var opt = {
            url: urlImg,
            formatImage: "png",
            enableOrientation: true,
            onAnnulation: function (e) { e.component.hide(); },
            onValidation: function (e) {
                //on a sauvegardé l'image en png
                mSaveImage()
                function mSaveImage() {
                    popCrop.hide();
                    option.bddCtrl.mAjaxCall({
                        command: "saveimgdata",
                        id_table: idTableRef,
                        id: idRef,
                        dataimg: e.component.dataImage
                    }, function (data) {
                        srcImg1 = pathNameImageToSave
                        mTriggerUpdate()
                        mConstruit()
                    }, function () {
                    }, function () {
                    });
                }
            }
        }
        if (srcImg1 != "") {
            opt.onSuppression = function (funcOk, funcAlways, funcKo) {
                srcImg1 = ""
                option.bddCtrl.mAjaxCall({
                    command: "delimgdata",
                    id_table: idTableRef,
                    id: idRef
                }, function (data) {
                    if ($DivImgStr) { $DivImgStr.remove(); $DivImgStr = null }
                    if ($DivImgCon) { $DivImgCon.remove(); $DivImgCon = null }
                    mTriggerUpdate()
                    mConstruit()
                }, function () {
                }, function () {
                });
                popCrop.hide();
            }
        }
        var popCrop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupCrop(opt).dxCtrlPopupCrop("instance")
        popCrop.show();

        function mTriggerUpdate() {
            $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.idTable + "'][id='" + option.id + "']").each(function (idx, ele) {
                var inst = $(ele).getInstance()
                if (typeof inst != "undefined" && inst != null) inst.mReload()
            })
            option.bddCtrl.triggerFunctionOnModifiedItemData(option.bddCtrl.table.mGetItem(option.idTable).nom, "modif", option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.idTable).nom, option.id).data)
            if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'structures') {
                option.bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(option.id, null, function (lst) {
                    lst.forEach(function (dataStrCon) {
                        $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + dataStrCon.id_structures_contact + "']").each(function (idx, ele) {
                            var inst = $(ele).getInstance()
                            if (typeof inst != "undefined" && inst != null) inst.mReload()
                        })
                    })
                })

                //bddCtrl.mAjaxCall({
                //    command: "getlstidstructurescontactfromstructures",
                //    id_structures: option.id
                //}, function (data) {
                //    if (!data.lstidstructurescontact) data.lstidstructurescontact = []
                //    data.lstidstructurescontact.forEach(function (idStrCon) {
                //        $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + idStrCon.id_structures_contact + "']").each(function (idx, ele) {
                //            var inst = $(ele).getInstance()
                //            if (typeof inst != "undefined" && inst != null) inst.mReload()
                //        })
                //    })
                //})
                ////option.bddCtrl.mGetArray("structures_contact").filter(function (o) { return o.id_structures == option.id }).forEach(function (data) {
                ////    $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact", data.id_structures_contact).mGetTable().id_table + "'][id='" + data.id_structures_contact + "']").each(function (idx, ele) {
                ////        var inst = $(ele).getInstance()
                ////        if (typeof inst != "undefined" && inst != null) inst.mReload()
                ////    })
                ////})
            }
            if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'contact') {
                option.bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(null, option.id, function (lst) {
                    lst.forEach(function (dataStrCon) {
                        $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + dataStrCon.id_structures_contact + "']").each(function (idx, ele) {
                            var inst = $(ele).getInstance()
                            if (typeof inst != "undefined" && inst != null) inst.mReload()
                        })
                    })
                })

                //bddCtrl.mAjaxCall({
                //    command: "getlstidstructurescontactfromcontact",
                //    id_contact: option.id
                //}, function (data) {
                //    if (!data.lstidstructurescontact) data.lstidstructurescontact = []
                //    data.lstidstructurescontact.forEach(function (idStrCon) {
                //        $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + idStrCon.id_structures_contact + "']").each(function (idx, ele) {
                //            var inst = $(ele).getInstance()
                //            if (typeof inst != "undefined" && inst != null) inst.mReload()
                //        })
                //    })
                //})
                ////option.bddCtrl.mGetArray("structures_contact").filter(function (o) { return o.id_contact == option.id }).forEach(function (data) {
                ////    $("body").find(".dx-ctrlimgstrconuti[id_table='" + option.bddCtrl.getObjet("structures_contact", data.id_structures_contact).mGetTable().id_table + "'][id='" + data.id_structures_contact + "']").each(function (idx, ele) {
                ////        var inst = $(ele).getInstance()
                ////        if (typeof inst != "undefined" && inst != null) inst.mReload()
                ////    })
                ////})
            }
        }
    }

    this.element = function () { return container }

    mConstruit();
}